module.exports = __webpack_public_path__ + "static/media/calendar-minus.f50a03bd.svg";